module.exports = "<app-header></app-header>\n\n<main class=\"main\">\n  <router-outlet></router-outlet>\n</main>\n"